module["exports"] = [
  "Bay",
  "Bayan",
  "Dr.",
  "Prof. Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/name/prefix.js
// module id = 2781
// module chunks = 2